
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5uGt2", function(module, exports) {
$parcel$export(module.exports, "useTabsContext", function () { return (parcelRequire("aeZV4")).useTabsContext; });
$parcel$export(module.exports, "Tabs", function () { return (parcelRequire("aeZV4")).Tabs; });
$parcel$export(module.exports, "DraggableTabList", function () { return (parcelRequire("6Iidb")).DraggableTabList; });
$parcel$export(module.exports, "DraggableTab", function () { return (parcelRequire("4q5Ua")).DraggableTab; });
$parcel$export(module.exports, "TabPanel", function () { return (parcelRequire("kFhJA")).TabPanel; });
$parcel$export(module.exports, "TabsSection", function () { return (parcelRequire("7kpd6")).TabsSection; });
$parcel$export(module.exports, "mapChild", function () { return (parcelRequire("jgQie")).mapChild; });

var $aeZV4 = parcelRequire("aeZV4");

var $6Iidb = parcelRequire("6Iidb");

var $4q5Ua = parcelRequire("4q5Ua");

var $kFhJA = parcelRequire("kFhJA");

var $7kpd6 = parcelRequire("7kpd6");

var $jgQie = parcelRequire("jgQie");

});
parcelRegister("aeZV4", function(module, exports) {
$parcel$export(module.exports, "useTabsContext", function () { return $0f3c3abb0b914582$export$5c3d36c3adf0ba92; });
$parcel$export(module.exports, "Tabs", function () { return $0f3c3abb0b914582$export$b2539bed5023c21c; });
/* tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6Ppys = parcelRequire("6Ppys");

var $edEzO = parcelRequire("edEzO");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $aHkxS = parcelRequire("aHkxS");

var $jgQie = parcelRequire("jgQie");
const $0f3c3abb0b914582$var$TabsContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $0f3c3abb0b914582$export$5c3d36c3adf0ba92 = ()=>{
    const context = (0, $1oC0p.useContext)($0f3c3abb0b914582$var$TabsContext);
    if (!context) throw new Error("useTabsContext must be used within Tabs");
    return context;
};
let $0f3c3abb0b914582$var$nextId = 0;
const $0f3c3abb0b914582$export$b2539bed5023c21c = ({ id: id, initialTab: initialTab, loop: loop = true, children: children, useInViewOptionsContainer: useInViewOptionsContainer })=>{
    const [currentTab, setCurrentTab] = (0, $1oC0p.useState)(initialTab !== null && initialTab !== void 0 ? initialTab : 0);
    const [userSelected, setUserSelected] = (0, $1oC0p.useState)(false);
    const [focus, setFocus] = (0, $1oC0p.useState)(false);
    const tabIds = (0, $1oC0p.useRef)([]);
    const contextId = (0, $1oC0p.useRef)(`:tabs:${id ? id : $0f3c3abb0b914582$var$nextId++}:`);
    const DEFAULT_IN_VIEW_THRESHOLD = 0.3;
    const { ref: containerScrollRef, inView: tabsContainerIsVisible } = (0, $jKShK.useInView)((0, $6Ppys._)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD
    }, useInViewOptionsContainer));
    const { ref: tabListScrollRef, inView: tabListIsVisible } = (0, $jKShK.useInView)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD
    });
    function getTabsCount() {
        let count = 0;
        (0, $jgQie.deepForEach)(children, (child)=>{
            if ((0, $jgQie.isTab)(child)) count++;
        });
        return count;
    }
    function getChildren() {
        const tabsCount = getTabsCount();
        let panelIndex = 0;
        tabIds.current = tabIds.current || [];
        let diff = tabIds.current.length - tabsCount;
        // Add ids if new tabs have been added
        // Don't bother removing ids, just keep them in case they are added again
        // This is more efficient, and keeps the uuid counter under control
        while(diff++ < 0)tabIds.current.push(`${contextId.current}${tabIds.current.length}`);
        // Map children to dynamically setup refs
        return (0, $jgQie.deepMap)(children, (child)=>{
            var _window_document_activeElement;
            let result = child;
            // Check if the window is available
            const windowAvailable = !!window && !!window.document && !!window.document.activeElement;
            // Get the active element id
            const activeElementId = windowAvailable ? (_window_document_activeElement = window.document.activeElement) === null || _window_document_activeElement === void 0 ? void 0 : _window_document_activeElement.id : null;
            // Clone TabList and Tab components to have refs
            if ((0, $jgQie.isTabList)(child)) {
                let listIndex = 0;
                // Figure out if the current focus in the DOM is set on a Tab
                // If it is we should keep the focus on the next selected tab
                let wasTabFocus = false;
                if (windowAvailable && activeElementId) // Check if the active element is a tab
                wasTabFocus = (0, $1oC0p.Children).toArray(child.props.children).filter((0, $jgQie.isTab)).some((_, i)=>{
                    return activeElementId === `tab${tabIds.current[i]}`;
                });
                result = /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, {
                    children: (0, $jgQie.deepMap)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    child.props.children, (tab)=>{
                        const selected = currentTab === listIndex;
                        const props = {
                            id: tabIds.current[listIndex],
                            tabIndex: listIndex,
                            focus: selected && (focus || wasTabFocus)
                        };
                        listIndex++;
                        return /*#__PURE__*/ (0, $1oC0p.cloneElement)(tab, props);
                    })
                });
            } else if ((0, $jgQie.isTabPanel)(child)) {
                // Preserve existing props (like hideTabPanelRole) when cloning
                const existingProps = child.props || {};
                const props = (0, $edEzO._)((0, $6Ppys._)({}, existingProps), {
                    id: tabIds.current[panelIndex],
                    panelIndex: panelIndex
                });
                panelIndex++;
                result = /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, props);
            }
            return result;
        });
    }
    const unsetUserSelected = ()=>{
        setUserSelected(false);
    };
    const goToTab = (tabIndex)=>{
        if (tabIndex === undefined) return;
        setCurrentTab(tabIndex);
        setUserSelected(true);
    };
    const isCurrentTab = (tabIndex)=>{
        return tabIndex === currentTab;
    };
    const goToNextTab = (0, $1oC0p.useCallback)(()=>{
        if (currentTab + 1 < tabIds.current.length) goToTab(currentTab + 1);
        else if (loop) goToTab(0);
    }, [
        loop,
        currentTab
    ]);
    const goToPrevTab = (0, $1oC0p.useCallback)(()=>{
        if (currentTab - 1 >= 0) goToTab(currentTab - 1);
        else if (loop) goToTab(tabIds.current.length - 1);
    }, [
        loop,
        currentTab
    ]);
    const goToFirstTab = ()=>{
        goToTab(0);
    };
    const goToLastTab = ()=>{
        goToTab(tabIds.current.length - 1);
    };
    const onKeyDown = (e)=>{
        if (e.code === "ArrowLeft" || e.code === "ArrowUp") goToPrevTab();
        else if (e.code === "ArrowRight" || e.code === "ArrowDown") goToNextTab();
        else if (e.code === "End") // Select last tab (End key)
        goToFirstTab();
        else if (e.code === "Home") // Select first tab (Home key)
        goToLastTab();
        else return;
        setUserSelected(true);
        setFocus(true);
        // This prevents scrollbars from moving around
        e.preventDefault();
    };
    // Reset the userSelected state when the section is visible again
    (0, $1oC0p.useEffect)(()=>{
        if (tabsContainerIsVisible) setUserSelected(false);
    }, [
        tabsContainerIsVisible
    ]);
    // Reinitialize analytics when the tab changes
    // this is needed because the content wasn't rendered before
    (0, $1oC0p.useEffect)(()=>{
        (0, $aHkxS.Initializer).autoTrack();
    }, [
        currentTab
    ]);
    const containerStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($0f3c3abb0b914582$var$TabsContext.Provider, {
        value: {
            currentTab: currentTab,
            userSelected: userSelected,
            unsetUserSelected: unsetUserSelected,
            goToTab: goToTab,
            isCurrentTab: isCurrentTab,
            goToNextTab: goToNextTab,
            goToPrevTab: goToPrevTab,
            goToFirstTab: goToFirstTab,
            goToLastTab: goToLastTab,
            onKeyDown: onKeyDown,
            tabsContainerIsVisible: tabsContainerIsVisible,
            tabListIsVisible: tabListIsVisible,
            tabListScrollRef: tabListScrollRef
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            ref: containerScrollRef,
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _zulp1jfw _1reo15vq _18m915vq"
            ]),
            children: getChildren()
        })
    });
};

});
parcelRegister("jgQie", function(module, exports) {
$parcel$export(module.exports, "isTab", function () { return $5fe887815c1bacdb$export$bdc9792d96913679; });
$parcel$export(module.exports, "isTabList", function () { return $5fe887815c1bacdb$export$9c326233b9ae5588; });
$parcel$export(module.exports, "isTabPanel", function () { return $5fe887815c1bacdb$export$9e12445c79db89b; });
$parcel$export(module.exports, "mapChild", function () { return $5fe887815c1bacdb$export$886f34b49305b07b; });
$parcel$export(module.exports, "deepMap", function () { return $5fe887815c1bacdb$export$ce7eaaed37329a1b; });
$parcel$export(module.exports, "deepForEach", function () { return $5fe887815c1bacdb$export$519ada94592b97fc; });

var $6Ppys = parcelRequire("6Ppys");

var $edEzO = parcelRequire("edEzO");

var $1oC0p = parcelRequire("1oC0p");
function $5fe887815c1bacdb$var$makeTypeChecker(tabsRole) {
    return (element)=>!!element.type && element.type.tabsRole === tabsRole;
}
const $5fe887815c1bacdb$export$bdc9792d96913679 = $5fe887815c1bacdb$var$makeTypeChecker("Tab");
const $5fe887815c1bacdb$export$9c326233b9ae5588 = $5fe887815c1bacdb$var$makeTypeChecker("TabList");
const $5fe887815c1bacdb$export$9e12445c79db89b = $5fe887815c1bacdb$var$makeTypeChecker("TabPanel");
const $5fe887815c1bacdb$export$dbaa4172856e20ab = (element)=>!!element.type && typeof element.type === "function";
function $5fe887815c1bacdb$var$isTabChild(child) {
    return $5fe887815c1bacdb$export$bdc9792d96913679(child) || $5fe887815c1bacdb$export$9c326233b9ae5588(child) || $5fe887815c1bacdb$export$9e12445c79db89b(child);
}
function $5fe887815c1bacdb$export$886f34b49305b07b(child, additionalProps) {
    if (child === null) return null;
    // Only pass additionalProps to functional components
    // React.cloneElement will throw an error if you pass additionalProps to a dom component like div
    if ($5fe887815c1bacdb$export$dbaa4172856e20ab(child)) return (0, $1oC0p.cloneElement)(child, (0, $6Ppys._)({}, child.props, additionalProps));
    return child;
}
function $5fe887815c1bacdb$export$ce7eaaed37329a1b(children, callback) {
    return (0, $1oC0p.Children).map(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return null;
        if ($5fe887815c1bacdb$var$isTabChild(child)) return callback(child, index);
        if (child && child.props && child.props.children && typeof child.props.children === "object") // Clone the child that has children and map them too
        return (0, $1oC0p.cloneElement)(child, (0, $edEzO._)((0, $6Ppys._)({}, child.props), {
            children: $5fe887815c1bacdb$export$ce7eaaed37329a1b(child.props.children, callback)
        }));
        return child;
    });
}
function $5fe887815c1bacdb$export$519ada94592b97fc(children, callback) {
    return (0, $1oC0p.Children).forEach(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return;
        if ($5fe887815c1bacdb$export$bdc9792d96913679(child) || $5fe887815c1bacdb$export$9e12445c79db89b(child)) callback(child, index);
        else if (child && child.props && child.props.children && typeof child.props.children === "object") {
            if ($5fe887815c1bacdb$export$9c326233b9ae5588(child)) callback(child, index);
            $5fe887815c1bacdb$export$519ada94592b97fc(child.props.children, callback);
        }
    });
}

});


parcelRegister("6Iidb", function(module, exports) {
$parcel$export(module.exports, "DraggableTabList", function () { return $5334c6b54e489af6$export$dbb4ac5a817c6612; });
/* draggable-tab-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
parcelRequire("5uGt2");
var $aeZV4 = parcelRequire("aeZV4");
const $5334c6b54e489af6$export$dbb4ac5a817c6612 = ({ alignment: alignment = "start", tabSize: // @ts-ignore
tabSize = "large", children: children })=>{
    const containerRef = (0, $1oC0p.useRef)(null);
    const mouseDown = (0, $1oC0p.useRef)(false);
    const startX = (0, $1oC0p.useRef)(0);
    const scrollLeft = (0, $1oC0p.useRef)(0);
    const canDrag = (0, $1oC0p.useRef)(false);
    const { onKeyDown: onKeyDown } = (0, $aeZV4.useTabsContext)();
    const startDragging = (mouse, touch)=>{
        var _containerRef_current;
        if (!canDrag.current) return;
        // Start listening for mouseup and mousemove events outside of the tab list
        document.addEventListener("mouseup", stopDragging);
        document.addEventListener("mousemove", move);
        mouseDown.current = true;
        var _ref;
        startX.current = (_ref = touch && touch.touches[0] ? touch.touches[0].clientX : mouse === null || mouse === void 0 ? void 0 : mouse.clientX) !== null && _ref !== void 0 ? _ref : 0;
        var _containerRef_current_scrollLeft;
        scrollLeft.current = (_containerRef_current_scrollLeft = (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.scrollLeft) !== null && _containerRef_current_scrollLeft !== void 0 ? _containerRef_current_scrollLeft : 0;
    };
    const stopDragging = ()=>{
        if (!canDrag.current) return;
        // Stop listening for mouseup and mousemove events
        document.removeEventListener("mouseup", stopDragging);
        document.removeEventListener("mousemove", move);
        mouseDown.current = false;
    };
    const move = (mouse, touch)=>{
        if (!canDrag.current || !mouseDown.current || !containerRef.current) return;
        let dragAmount = 0;
        if (touch && touch.changedTouches[0]) dragAmount = touch.changedTouches[0].clientX - startX.current;
        else if (mouse) dragAmount = mouse.clientX - startX.current;
        containerRef.current.scrollLeft = scrollLeft.current - dragAmount;
    };
    (0, $1oC0p.useEffect)(()=>{
        const updateCanDrag = ()=>{
            if (containerRef.current) {
                const container = containerRef.current;
                canDrag.current = container.scrollWidth > container.clientWidth;
            }
        };
        const setStartingPoint = ()=>{
            if (containerRef.current) {
                if (canDrag.current) {
                    const tabPanels = document.querySelector(".tab-panels");
                    const tabPanelsStyle = tabPanels && window.getComputedStyle(tabPanels);
                    containerRef.current.setAttribute("style", `padding-left: calc(${tabPanelsStyle === null || tabPanelsStyle === void 0 ? void 0 : tabPanelsStyle.marginLeft} + ${tabPanelsStyle === null || tabPanelsStyle === void 0 ? void 0 : tabPanelsStyle.paddingLeft});`);
                } else if (alignment === "start") containerRef.current.setAttribute("style", "margin-inline: 0px; padding-inline: 0px;");
            }
        };
        if (!containerRef.current) return;
        const observer = new ResizeObserver(()=>{
            updateCanDrag();
            setStartingPoint();
        });
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    });
    const wrapperStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: containerRef,
        className: (0, $2jatx.default)([
            "_1reo15vq _p12f1osq _195g1wug _18zrzwfg _11q81vi7 _su071wqb _3hzp1wqb"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            // @ts-ignore
            onTouchStart: (e)=>startDragging(undefined, e),
            // @ts-ignore
            onMouseDown: (e)=>startDragging(e),
            // @ts-ignore
            onTouchEnd: (e)=>{
                // @ts-ignore
                move(undefined, e);
                stopDragging();
            },
            // @ts-ignore
            onTouchMove: (e)=>move(undefined, e),
            onKeyDown: onKeyDown,
            className: (0, $2jatx.default)([
                "_1e0c1txw _4cvr1y6m _1bah1y6m _1n261q9c _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw _1bsb1ns9 _p12f1osq _1moupxbi _zulp1ejb",
                "tab-list"
            ]),
            tabIndex: -1,
            role: "tablist",
            children: children
        })
    });
};
const $5334c6b54e489af6$var$tabsContainerStyles = null;
$5334c6b54e489af6$export$dbb4ac5a817c6612.tabsRole = "TabList";

});

parcelRegister("4q5Ua", function(module, exports) {
$parcel$export(module.exports, "DraggableTab", function () { return $2726a747230786c6$export$3a29ca89d63c5c20; });
/* draggable-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6Ppys = parcelRequire("6Ppys");

var $edEzO = parcelRequire("edEzO");

var $6yaZc = parcelRequire("6yaZc");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
parcelRequire("5uGt2");
var $aeZV4 = parcelRequire("aeZV4");
const $2726a747230786c6$export$3a29ca89d63c5c20 = (_param)=>{
    var { id: id, focus: focus, tabIndex: tabIndex, title: title, iconUrl: iconUrl, tabSize: tabSize = "large", bgColor: bgColor = "bgWhite", label: label, dataEventProps: dataEventProps, className: className, enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false, children: children } = _param, props = (0, $6yaZc._)(_param, [
        "id",
        "focus",
        "tabIndex",
        "title",
        "iconUrl",
        "tabSize",
        "bgColor",
        "label",
        "dataEventProps",
        "className",
        "enableRovoBorder",
        "enableResponsiveTabSize",
        "children"
    ]);
    const { goToTab: goToTab, isCurrentTab: isCurrentTab, userSelected: userSelected } = (0, $aeZV4.useTabsContext)();
    const startX = (0, $1oC0p.useRef)(0);
    const tabRef = /*#__PURE__*/ (0, $1oC0p.createRef)();
    const isTabSelected = isCurrentTab(tabIndex);
    (0, $1oC0p.useEffect)(()=>{
        if (!tabRef.current || !tabRef.current.parentElement || !tabRef.current.parentElement.scrollTo || !tabRef.current.parentElement.parentElement || !tabRef.current.parentElement.parentElement.scrollTo) return;
        // Scroll to the selected tab if it's not in view
        if (isTabSelected) {
            var _tabRef_current_parentElement;
            if ((_tabRef_current_parentElement = tabRef.current.parentElement) === null || _tabRef_current_parentElement === void 0 ? void 0 : _tabRef_current_parentElement.parentElement) {
                // calculate the offset to center the tab in the parent
                const offsetLeft = tabRef.current.offsetLeft - tabRef.current.parentElement.offsetLeft - tabRef.current.parentElement.offsetWidth / 2 + tabRef.current.offsetWidth / 2;
                tabRef.current.parentElement.parentElement.scrollTo({
                    left: offsetLeft,
                    top: 0,
                    behavior: "smooth"
                });
            }
            if (focus) tabRef.current.focus({
                preventScroll: true
            });
        }
        if (isTabSelected && dataEventProps && userSelected) tabRef.current.dispatchEvent(new Event("select"));
    }, [
        tabRef,
        isTabSelected,
        focus,
        userSelected,
        dataEventProps
    ]);
    const onMouseDown = (e)=>{
        var _props_onMouseDown;
        var _e_clientX;
        startX.current = (_e_clientX = e.clientX) !== null && _e_clientX !== void 0 ? _e_clientX : 0;
        (_props_onMouseDown = props.onMouseDown) === null || _props_onMouseDown === void 0 ? void 0 : _props_onMouseDown.call(props, e);
    };
    const onClick = (0, $1oC0p.useCallback)((e)=>{
        var _props_onClick;
        if (Math.abs(e.clientX - startX.current) > 15) // Prevent click event if user is dragging
        return;
        (_props_onClick = props.onClick) === null || _props_onClick === void 0 ? void 0 : _props_onClick.call(props, e);
        if (isTabSelected) return;
        goToTab(tabIndex);
    }, [
        isTabSelected,
        tabIndex,
        goToTab,
        props
    ]);
    const onKeyDown = (e)=>{
        if (e.code === "Space" || e.code === "Enter") {
            goToTab(tabIndex);
            e.preventDefault();
        }
    };
    const tabColor = bgColor === "bgWhite" ? (0, $kbpa7.wacToken)("color.neutral.light200") : (0, $kbpa7.wacToken)("color.neutral.light0");
    const tabStyles = null;
    const rovoBorderStyles = null;
    const borderStyles = null;
    const largeTabStyles = null;
    const smallTabStyles = null;
    const iconTabStyles = null;
    const iconLargeTabStyles = null;
    const iconSmallTabStyles = null;
    const responsiveIconTabStyles = null;
    const iconLargeContainerStyles = null;
    const iconSmallContainerStyles = null;
    const responsiveIconContainerStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", (0, $edEzO._)((0, $6Ppys._)({}, props), {
        // @ts-ignore
        ref: tabRef,
        // @ts-ignore
        className: className,
        children: !!children ? /*#__PURE__*/ (0, $1oC0p.cloneElement)(children, (0, $6Ppys._)({
            onMouseDown: // @ts-ignore
            onMouseDown,
            onClick: // @ts-ignore
            onClick,
            onKeyDown: // @ts-ignore
            onKeyDown
        }, dataEventProps)) : /*#__PURE__*/ (0, $7VQPk.jsxs)("button", (0, $edEzO._)((0, $6Ppys._)({
            id: `tab${id}`,
            role: "tab",
            "aria-selected": isTabSelected,
            "aria-controls": `panel${id}`,
            "aria-label": label,
            title: label,
            className: (0, $2jatx.default)([
                "_o5721q9c _1ul9ymf6 _bfhk1jrh _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko17td _19itq75r _80omtlke _4cvx17la _8y9r1hlo",
                iconUrl && "_2lx21bp4 _2rkoi2wt _1wyb1j6v",
                iconUrl && enableRovoBorder ? "_1h6d1j28 _1s79mzrp _1esp1ws1 _494pusvi _iusibx47" : "_1npj1ybm _1s7917la",
                iconUrl && enableResponsiveTabSize && "_4t3i1n2x _1ul9176v _1yt437zh _1xlocmky _1d2y11ux _6ytt139i",
                !iconUrl && tabSize === "large" && "_ca0qdlk8 _u5f31f4h _n3tddlk8 _19bv1f4h _vwz41f4h _4t3i1wqb _1wyb1cby",
                !iconUrl && tabSize === "small" && "_1yt41c98 _vwz4v47k _4t3i1ylp _1wyb1j6v",
                iconUrl && !enableResponsiveTabSize && tabSize === "large" && "_4t3icmky _1ul911ux _1yt4139i",
                iconUrl && !enableResponsiveTabSize && tabSize === "small" && "_4t3i1n2x _1ul9176v _1yt437zh",
                `${isTabSelected ? "currentTab" : ""}`
            ]),
            // how to adjust for different page? or just remove?
            "data-product-key": "template",
            "data-event": "clicked",
            "data-event-component": "button",
            "data-event-container": "tabsMenu",
            "data-label": title,
            // @ts-ignore
            onMouseDown: onMouseDown,
            // @ts-ignore
            onClick: onClick,
            // @ts-ignore
            onKeyDown: onKeyDown
        }, dataEventProps), {
            style: {
                "--_7aj7gm": (0, $6ZVlx.default)(tabColor),
                "--_514je1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.pill")),
                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
            },
            children: [
                iconUrl && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        !enableResponsiveTabSize && tabSize === "large" && "_4t3ickbl _1bsbckbl",
                        !enableResponsiveTabSize && tabSize === "small" && "_4t3i10mc _1bsb10mc",
                        enableResponsiveTabSize && "_4t3i10mc _1bsb10mc _1xlockbl _14b5ckbl",
                        "default-icon"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Image), {
                        src: `${iconUrl || ""}`,
                        alt: "",
                        draggable: false
                    })
                }),
                title
            ]
        }))
    }));
};
$2726a747230786c6$export$3a29ca89d63c5c20.tabsRole = "Tab";

});

parcelRegister("kFhJA", function(module, exports) {
$parcel$export(module.exports, "TabPanel", function () { return $73f95d72bd57759d$export$3d96ec278d3efce4; });
/* tab-panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6Ppys = parcelRequire("6Ppys");

var $edEzO = parcelRequire("edEzO");

var $6yaZc = parcelRequire("6yaZc");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lTkkF = parcelRequire("lTkkF");
parcelRequire("5uGt2");
var $jgQie = parcelRequire("jgQie");
var $aeZV4 = parcelRequire("aeZV4");
const $73f95d72bd57759d$var$hidePanelStyle = null;
const $73f95d72bd57759d$export$3d96ec278d3efce4 = (_param)=>{
    var { forceRender: forceRender, children: children, panelIndex: panelIndex, id: id, hideTabPanelRole: hideTabPanelRole } = _param, props = (0, $6yaZc._)(_param, [
        "forceRender",
        "children",
        "panelIndex",
        "id",
        "hideTabPanelRole"
    ]);
    const { isCurrentTab: isCurrentTab } = (0, $aeZV4.useTabsContext)();
    const isTabSelected = isCurrentTab(panelIndex);
    const activeClass = isTabSelected ? "active-panel" : "";
    const { panelId: panelId, tabId: tabId } = (0, $lTkkF.generateSafeIds)(id, panelIndex);
    const originalChildrenCount = (0, $1oC0p.Children).count(children);
    const shouldHideRole = hideTabPanelRole !== undefined ? hideTabPanelRole : originalChildrenCount === 0;
    const { css: existingCss } = props, propsWithoutCss = (0, $6yaZc._)(props, [
        "css"
    ]);
    const filteredProps = Object.fromEntries(Object.entries(propsWithoutCss).filter(([key])=>!key.startsWith("aria-") && key !== "role"));
    const inlineHideStyle = !isTabSelected && !forceRender ? {
        display: "none"
    } : undefined;
    if (!shouldHideRole) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", (0, $edEzO._)((0, $6Ppys._)({}, filteredProps), {
        style: inlineHideStyle,
        id: panelId,
        "data-testid": panelId,
        "aria-labelledby": tabId,
        "aria-hidden": !isTabSelected,
        role: "tabpanel",
        className: (0, $2jatx.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                "tab-panel",
                activeClass
            ].join(" ")
        ]),
        children: (0, $1oC0p.Children).map(children, (child)=>{
            return (0, $jgQie.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    }));
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: inlineHideStyle,
        id: panelId,
        "data-testid": panelId,
        className: (0, $2jatx.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                "tab-panel",
                activeClass
            ].join(" ")
        ]),
        "aria-labelledby": undefined,
        "aria-hidden": undefined,
        role: undefined,
        children: (0, $1oC0p.Children).map(children, (child)=>{
            return (0, $jgQie.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    });
};
$73f95d72bd57759d$export$3d96ec278d3efce4.tabsRole = "TabPanel";

});

parcelRegister("7kpd6", function(module, exports) {
$parcel$export(module.exports, "TabsSection", function () { return $55e394e1b826b27b$export$502de1d4d55224c1; });
/* tabs-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");
parcelRequire("5uGt2");
var $4q5Ua = parcelRequire("4q5Ua");
var $6Iidb = parcelRequire("6Iidb");
var $kFhJA = parcelRequire("kFhJA");
var $aeZV4 = parcelRequire("aeZV4");
const $55e394e1b826b27b$export$502de1d4d55224c1 = ({ alignment: alignment = "start", tabsData: tabsData, tabSize: tabSize = "large", bgColor: bgColor = "bgWhite", enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false })=>{
    const sectionStyles = null;
    const fullWidthContainerStyles = null;
    const enableIconTabs = tabsData.every((tab)=>tab.iconUrl);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        id: "tabs",
        className: (0, $2jatx.default)([
            "_1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $aeZV4.Tabs), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Iidb.DraggableTabList), {
                    tabSize: tabSize,
                    alignment: alignment,
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $4q5Ua.DraggableTab), {
                            tabIndex: index,
                            title: tab.title,
                            iconUrl: enableIconTabs ? tab.iconUrl : undefined,
                            tabSize: tabSize,
                            bgColor: bgColor,
                            className: "round-tab",
                            enableRovoBorder: enableIconTabs && enableRovoBorder,
                            enableResponsiveTabSize: enableIconTabs && enableResponsiveTabSize
                        }, index))
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        tabSize === "large" && "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _1reoewfl _18m9ewfl _bozgzwfg _y4tizwfg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx",
                        "tab-panels"
                    ]),
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $kFhJA.TabPanel), {
                            panelIndex: index,
                            id: tab.id || `tab-${index}`,
                            children: tab.tabComponent
                        }, index))
                })
            ]
        })
    });
};

});


parcelRegister("hXSMk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76f067d08aa7c324d1505318ade2e26f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d14270378c3131a7$var$_react = $d14270378c3131a7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $d14270378c3131a7$var$_baseNew = $d14270378c3131a7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $d14270378c3131a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Alert".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for alerts in JSM and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d14270378c3131a7$var$AlertIcon = (props)=>/*#__PURE__*/ $d14270378c3131a7$var$_react.default.createElement($d14270378c3131a7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 0v3h-1.5V0zM2.123 1.063 4.172 3.11 3.11 4.17 1.063 2.124zm12.814 1.06L12.89 4.172 11.83 3.11l2.047-2.048zM4.195 5.875A1.5 1.5 0 0 1 5.69 4.5h4.62a1.5 1.5 0 0 1 1.495 1.375l.635 7.625H14V15H2v-1.5h1.56zm.87 7.625h5.87L10.31 6H5.69z" clip-rule="evenodd"/>`
    }, props));
$d14270378c3131a7$var$AlertIcon.displayName = 'AlertIcon';
var $d14270378c3131a7$var$_default = module.exports.default = $d14270378c3131a7$var$AlertIcon;

});

parcelRegister("eOOWL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::54f75e2054943fb775b789c9f2b57e27>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ac9d412ae10a01ab$var$_react = $ac9d412ae10a01ab$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ac9d412ae10a01ab$var$_baseNew = $ac9d412ae10a01ab$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $ac9d412ae10a01ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ac9d412ae10a01ab$var$ChartBarIcon = (props)=>/*#__PURE__*/ $ac9d412ae10a01ab$var$_react.default.createElement($ac9d412ae10a01ab$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$ac9d412ae10a01ab$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $ac9d412ae10a01ab$var$_default = module.exports.default = $ac9d412ae10a01ab$var$ChartBarIcon;

});

parcelRegister("kzcfD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::de887aadbfedd5e674ee79e9bf8242ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef90945cc818a91e$var$_react = $ef90945cc818a91e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ef90945cc818a91e$var$_baseNew = $ef90945cc818a91e$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $ef90945cc818a91e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LobbyBell".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: risks in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef90945cc818a91e$var$LobbyBellIcon = (props)=>/*#__PURE__*/ $ef90945cc818a91e$var$_react.default.createElement($ef90945cc818a91e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1h4v1.5H8.75v1.75h.92a4.75 4.75 0 0 1 4.72 4.225l.355 3.192A.75.75 0 0 1 14 12.5H2a.75.75 0 0 1-.745-.833l.354-3.192A4.75 4.75 0 0 1 6.33 4.25h.92V2.5H6zm.33 4.75A3.25 3.25 0 0 0 3.1 8.641L2.838 11h10.324L12.9 8.641A3.25 3.25 0 0 0 9.67 5.75zM15 13.5V15H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$ef90945cc818a91e$var$LobbyBellIcon.displayName = 'LobbyBellIcon';
var $ef90945cc818a91e$var$_default = module.exports.default = $ef90945cc818a91e$var$LobbyBellIcon;

});

parcelRegister("PQhz5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f64abe706416b0877b5dd221be64e7d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09bd51b6223980e7$var$_react = $09bd51b6223980e7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $09bd51b6223980e7$var$_baseNew = $09bd51b6223980e7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $09bd51b6223980e7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09bd51b6223980e7$var$PageIcon = (props)=>/*#__PURE__*/ $09bd51b6223980e7$var$_react.default.createElement($09bd51b6223980e7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$09bd51b6223980e7$var$PageIcon.displayName = 'PageIcon';
var $09bd51b6223980e7$var$_default = module.exports.default = $09bd51b6223980e7$var$PageIcon;

});

parcelRegister("9Cyyz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $701277dc6e7898a3$var$_react = $701277dc6e7898a3$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $701277dc6e7898a3$var$_baseNew = $701277dc6e7898a3$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $701277dc6e7898a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $701277dc6e7898a3$var$AutomationIcon = (props)=>/*#__PURE__*/ $701277dc6e7898a3$var$_react.default.createElement($701277dc6e7898a3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$701277dc6e7898a3$var$AutomationIcon.displayName = 'AutomationIcon';
var $701277dc6e7898a3$var$_default = module.exports.default = $701277dc6e7898a3$var$AutomationIcon;

});

parcelRegister("efg6m", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c939fd7642839817f37f5fef435fb296>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a5eef4da1ee45f40$var$_react = $a5eef4da1ee45f40$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a5eef4da1ee45f40$var$_baseNew = $a5eef4da1ee45f40$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $a5eef4da1ee45f40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a5eef4da1ee45f40$var$ChangesIcon = (props)=>/*#__PURE__*/ $a5eef4da1ee45f40$var$_react.default.createElement($a5eef4da1ee45f40$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$a5eef4da1ee45f40$var$ChangesIcon.displayName = 'ChangesIcon';
var $a5eef4da1ee45f40$var$_default = module.exports.default = $a5eef4da1ee45f40$var$ChangesIcon;

});

parcelRegister("FI4AH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fb18bc89cea9c558386c877fcbee03e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07d604706fb56cdd$var$_react = $07d604706fb56cdd$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $07d604706fb56cdd$var$_baseNew = $07d604706fb56cdd$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $07d604706fb56cdd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrendUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Upward trending data; Trend charts; Reports in Jira; Sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $07d604706fb56cdd$var$ChartTrendUpIcon = (props)=>/*#__PURE__*/ $07d604706fb56cdd$var$_react.default.createElement($07d604706fb56cdd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M15 7.5h-1.5V5.56L9.78 9.28a.75.75 0 0 1-1.06 0L7.25 7.81l-2.22 2.22-1.06-1.06 2.75-2.75.056-.052a.75.75 0 0 1 1.004.052l1.47 1.47 3.19-3.19H10.5V3h3.75a.75.75 0 0 1 .75.75z"/>`
    }, props));
$07d604706fb56cdd$var$ChartTrendUpIcon.displayName = 'ChartTrendUpIcon';
var $07d604706fb56cdd$var$_default = module.exports.default = $07d604706fb56cdd$var$ChartTrendUpIcon;

});

parcelRegister("bf5rK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aff4cd926156d74fe58acdf2d87dd6f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $82f551fa44ba4d63$var$_react = $82f551fa44ba4d63$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $82f551fa44ba4d63$var$_baseNew = $82f551fa44ba4d63$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $82f551fa44ba4d63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $82f551fa44ba4d63$var$PagesIcon = (props)=>/*#__PURE__*/ $82f551fa44ba4d63$var$_react.default.createElement($82f551fa44ba4d63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$82f551fa44ba4d63$var$PagesIcon.displayName = 'PagesIcon';
var $82f551fa44ba4d63$var$_default = module.exports.default = $82f551fa44ba4d63$var$PagesIcon;

});

parcelRegister("ggVkr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7c8caaba4b6537db98d2e63ce6d8f75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd8a9c39c889598d$var$_react = $bd8a9c39c889598d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $bd8a9c39c889598d$var$_baseNew = $bd8a9c39c889598d$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $bd8a9c39c889598d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd8a9c39c889598d$var$PersonAddIcon = (props)=>/*#__PURE__*/ $bd8a9c39c889598d$var$_react.default.createElement($bd8a9c39c889598d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m11.25 4.75V11h1.5V8.75H16v-1.5h-2.25V5h-1.5v2.25H10v1.5zm-8.5 1.75a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.5A3.75 3.75 0 0 1 10 12.75V15H8.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$bd8a9c39c889598d$var$PersonAddIcon.displayName = 'PersonAddIcon';
var $bd8a9c39c889598d$var$_default = module.exports.default = $bd8a9c39c889598d$var$PersonAddIcon;

});

parcelRegister("35vmV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3a8c88470e968ec08c5aa075e8f42b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23fa2be7417a36cb$var$_react = $23fa2be7417a36cb$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $23fa2be7417a36cb$var$_baseNew = $23fa2be7417a36cb$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $23fa2be7417a36cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBubble".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bubble and matrix charts; Matrix view in in JPD
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23fa2be7417a36cb$var$ChartBubbleIcon = (props)=>/*#__PURE__*/ $23fa2be7417a36cb$var$_react.default.createElement($23fa2be7417a36cb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M11.27 9.01a1.38 1.38 0 1 1-1.51 1.51l-.01-.14.01-.14A1.38 1.38 0 0 1 11.13 9zM5.75 6.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m4.75-5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"/>`
    }, props));
$23fa2be7417a36cb$var$ChartBubbleIcon.displayName = 'ChartBubbleIcon';
var $23fa2be7417a36cb$var$_default = module.exports.default = $23fa2be7417a36cb$var$ChartBubbleIcon;

});

parcelRegister("k2zyM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d288013ed94ec7ddbe1bb143e39a4fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e96f93ff829ead8b$var$_react = $e96f93ff829ead8b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $e96f93ff829ead8b$var$_baseNew = $e96f93ff829ead8b$var$_interopRequireDefault((parcelRequire("jcI35")));
function $e96f93ff829ead8b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BrowserExtension".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for chrome extensions
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e96f93ff829ead8b$var$BrowserExtensionIcon = (props)=>/*#__PURE__*/ $e96f93ff829ead8b$var$_react.default.createElement($e96f93ff829ead8b$var$_baseNew.default, Object.assign({
        name: "BrowserExtensionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.25 2v.5h2.25a2 2 0 0 1 2 2v2.25h.5a2 2 0 1 1 0 4h-.5V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2.25a.75.75 0 0 1 .75-.75h.5a1.25 1.25 0 1 0 0-2.5h-.5A.75.75 0 0 1 1 6.75V4.5a2 2 0 0 1 2-2h2.25V2a2 2 0 1 1 4 0M2.5 4.5A.5.5 0 0 1 3 4h8.5a.5.5 0 0 1 .5.5V13a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-1.511a2.75 2.75 0 0 0 0-5.478z" clip-rule="evenodd"/>`
    }, props));
$e96f93ff829ead8b$var$BrowserExtensionIcon.displayName = 'BrowserExtensionIcon';
var $e96f93ff829ead8b$var$_default = module.exports.default = $e96f93ff829ead8b$var$BrowserExtensionIcon;

});

parcelRegister("7JEHy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62b2367dcefa534d3cc5e1a7e205b220>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a1c4ed3f3b8d061$var$_react = $5a1c4ed3f3b8d061$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5a1c4ed3f3b8d061$var$_baseNew = $5a1c4ed3f3b8d061$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $5a1c4ed3f3b8d061$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Goal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a1c4ed3f3b8d061$var$GoalIcon = (props)=>/*#__PURE__*/ $5a1c4ed3f3b8d061$var$_react.default.createElement($5a1c4ed3f3b8d061$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0" clip-rule="evenodd"/>`
    }, props));
$5a1c4ed3f3b8d061$var$GoalIcon.displayName = 'GoalIcon';
var $5a1c4ed3f3b8d061$var$_default = module.exports.default = $5a1c4ed3f3b8d061$var$GoalIcon;

});

parcelRegister("bOuCy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab25c6896d727bd4806885f3b789ade9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $899c1ddf7bade55b$var$_react = $899c1ddf7bade55b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $899c1ddf7bade55b$var$_baseNew = $899c1ddf7bade55b$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $899c1ddf7bade55b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $899c1ddf7bade55b$var$BugIcon = (props)=>/*#__PURE__*/ $899c1ddf7bade55b$var$_react.default.createElement($899c1ddf7bade55b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$899c1ddf7bade55b$var$BugIcon.displayName = 'BugIcon';
var $899c1ddf7bade55b$var$_default = module.exports.default = $899c1ddf7bade55b$var$BugIcon;

});

parcelRegister("2GO8b", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f5663fd08175dde$var$_react = $1f5663fd08175dde$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1f5663fd08175dde$var$_baseNew = $1f5663fd08175dde$var$_interopRequireDefault((parcelRequire("jcI35")));
function $1f5663fd08175dde$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1f5663fd08175dde$var$NotepadIcon = (props)=>/*#__PURE__*/ $1f5663fd08175dde$var$_react.default.createElement($1f5663fd08175dde$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$1f5663fd08175dde$var$NotepadIcon.displayName = 'NotepadIcon';
var $1f5663fd08175dde$var$_default = module.exports.default = $1f5663fd08175dde$var$NotepadIcon;

});

parcelRegister("6xXDI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::840e9064aa0761adacec2a7ce2dee628>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c441650e47ff0d3$var$_react = $4c441650e47ff0d3$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4c441650e47ff0d3$var$_baseNew = $4c441650e47ff0d3$var$_interopRequireDefault((parcelRequire("jcI35")));
function $4c441650e47ff0d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4c441650e47ff0d3$var$SyncIcon = (props)=>/*#__PURE__*/ $4c441650e47ff0d3$var$_react.default.createElement($4c441650e47ff0d3$var$_baseNew.default, Object.assign({
        name: "SyncIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$4c441650e47ff0d3$var$SyncIcon.displayName = 'SyncIcon';
var $4c441650e47ff0d3$var$_default = module.exports.default = $4c441650e47ff0d3$var$SyncIcon;

});


//# sourceMappingURL=home.5f5702e6.js.map
